// frontend/src/labels.js
// Persian labels for backend choice-fields, kept in one place so pages agree.

export const CONTRACT_LABELS = { hourly: 'ساعتی', daily: 'روزانه', monthly: 'ماهانه' };
export const SHIFT_LABELS = { day: 'روز', night: 'شب', '24h': 'شبانه‌روزی' };
export const REQUEST_STATUS_LABELS = {
    pending: 'در انتظار پیشنهاد',
    active: 'در حال انجام',
    completed: 'تکمیل‌شده',
    cancelled: 'لغوشده',
};
export const BID_STATUS_LABELS = {
    submitted: 'ارسال‌شده',
    accepted: 'پذیرفته‌شده',
    rejected: 'ردشده',
};

export const formatRial = (value) => {
    if (value === null || value === undefined || value === '') return '—';
    const n = Number(value);
    if (Number.isNaN(n)) return '—';
    return n.toLocaleString('fa-IR') + ' ریال';
};

export const formatToman = (value) => {
    if (value === null || value === undefined || value === '') return '—';
    const n = Number(value);
    if (Number.isNaN(n)) return '—';
    return Math.round(n / 10).toLocaleString('fa-IR') + ' تومان';
};
